import React from 'react';
import { Box, Alert, AlertTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

/**
 * Standard InfoBanner - Matches SnackbarAlert branding
 */
const InfoBanner = ({
  show,
  title,
  message,
  onClose,
  isDark,
  severity = "success"
}) => {
  const { t } = useTranslation();
  if (!show) return null;

  return (
    <Box sx={{ mt: 3, mb: 2, animation: "org-fadeInUp 0.4s ease" }}>
      <Alert
        onClose={onClose}
        severity={severity}
        variant="standard"
        icon={<AutoAwesomeIcon sx={{ fontSize: 22, color: "#fff" }} />}
        sx={{
          borderRadius: "12px",
          backgroundColor: isDark ? "rgba(21, 164, 72, 0.15)" : "rgba(21, 164, 72, 0.05)",
          border: "1px solid #15a448",
          color: isDark ? "#fff" : "#1b1b1b",
          "& .MuiAlert-icon": {
            backgroundColor: "#15a448",
            borderRadius: "50%",
            p: "6px",
            mr: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          "& .MuiAlert-message": {
            width: "100%",
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            paddingY: "4px"
          },
          "& .MuiAlert-action": {
            alignItems: "center"
          }
        }}
      >
        <AlertTitle sx={{ 
          fontWeight: 700, 
          mb: 0.5, 
          fontSize: "1rem", 
          fontFamily: "'Inter', sans-serif",
          color: "#15a448"
        }}>
          {t(title)}
        </AlertTitle>
        <Typography variant="body2" sx={{ 
          fontSize: "0.9rem", 
          lineHeight: 1.5,
          fontFamily: "'Inter', sans-serif",
          textAlign: "left"
        }}>
          {message}
        </Typography>
      </Alert>
    </Box>
  );
};

export default InfoBanner;
